import business from '@/api/product/business-unit'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return business.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return business.store(data)
  },
  update(context, { id, data }) {
    return business.update(id, data)
  },
  destroy(context, id){
    return business.destroy(id)
  }
}